import styled from "@emotion/styled";

export const Root = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	/* library limitation: overriding inline background-image styles requires !important */
	&[data-pad-images] div[style*="background-image"] {
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
	}

	/* First card is the OOS selected item — dim it */
	&[data-oos] > * > * > *:first-child {
		opacity: 0.5;
		border-style: dashed;
		pointer-events: none;
	}
`;

export const FieldLabel = styled.div`
	font-size: ${({ theme }) => theme.typography.fontSize.small};
	font-weight: 500;
	color: ${({ theme }) => theme.colors.foregrounds[3]};
	padding: 0 4px;
`;
